import {
  Component,
  OnInit,
  ViewChild,
  EventEmitter,
  QueryList,
  ViewChildren,
} from "@angular/core";

import { MappingRemediationService } from "src/app/services/mappingRemediation.service";
import { Sharedservice } from "./../../shared-components/shared.service";
import { UserService } from "../../services/user.service";
import { ActivatedRoute, Router } from "@angular/router";
import { Table } from "primeng/table";
import {
  MessageService,
  ConfirmationService,
  LazyLoadEvent,
} from "primeng/api";
import {
  severitymessage,
  LanguageConstants,
} from "../../shared-components/constant";
import { EngagementService } from "src/app/services/engagement.service";

import { UserModel } from "../../models/user.model";
import {
  UploadFile,
  UploaderOptions,
  UploadInput,
  humanizeBytes,
  UploadOutput,
} from "ngx-uploader";
import { environment } from "../../../environments/environment";
import { ErrorPopUpModel } from "../../models/errorpopup.model";
import { ResponseMessage } from "src/app/models/ResponseMessage.model";
import { NGXLogger } from "ngx-logger";
import { WebJobQueueService } from "src/app/services/webjobqueue.service";
import { WebJobQueueModel } from "src/app/models/webJobQueue.model";
import { InfraService } from "src/app/services/infra.service";
import { TemplateEnum } from "src/app/enums/regions.enum";
import { MultiSelect } from "primeng/multiselect";
import { LangChangeEvent, TranslateService } from "@ngx-translate/core";
import { HttpClient } from "@angular/common/http";
import { forkJoin } from "rxjs";
import { EngagementModel } from "src/app/models/engagement.model";
import { MasterHelpService } from "src/app/services/masterhelp.service";
import { AuditingService } from "../../services/auditing.service";
import { saveAs } from "file-saver";
import { AppConfigurationService } from "./../../services/appConfiguration.service";
import { AppConfigurationsModel } from "./../../models/appConfigurations.model";
import { Observable } from "rxjs";

enum AccountLibraryMatch {
  SMIDNOTSelected = 1,
  Warning = 2,
  NotFound = 3,
  Found = 4,
}

@Component({
  selector: "app-remediation",
  templateUrl: "./remediation.component.html",
  styleUrls: ["./remediation.component.css"],
})
export class RemediationComponent implements OnInit {
  show = false;
  engagementId = +this.route.snapshot.paramMap.get("id");
  loadspinner = false;
  suggestionListFlag = false;
  loadspinnerdownloadmapping = false;
  loadspinneruploadmapping = false;
  isEngagementReadOnly: boolean = false;
  loggedInUserId: number;
  checkAll: boolean;
  mappingSource: number;
  selectedSuggestionData = [];
  suggestionCondition = "OR";
  mappingCount = 6;
  humanizeBytes: Function;
  cols: any[];
  mapData: any;
  //public engagement: EngagementModel;
  @ViewChild("dt", { static: true }) private _table: Table;
  @ViewChildren("multiselect") components: QueryList<MultiSelect>;
  globalStdMapping: any;
  mappngSuggestion = [];
  selecteditemsRoot = [];
  loadIsvalid = false;
  loading: boolean;
  variable: string;
  isMappingVisible = false;
  normalConfirmKey = "normal";
  normalConfirmKeyDelete = "normalDelete";
  libraryConfirmCustomKey = "pushLibraryContinueBack";
  buttonText = "Download mappings";
  flatfile: any;
  private isPnP: boolean;
  options: UploaderOptions;
  sourceFiles: UploadFile[];
  uploadInput: EventEmitter<UploadInput>;
  configUrl: string;
  uploadDisabled = false;
  fileUploadedAsTemplateFlatfile = false;
  dragOver: boolean;
  finalheight: any = 0;
  errorModel: ErrorPopUpModel = new ErrorPopUpModel();
  responseMessage: ResponseMessage = new ResponseMessage();
  verificationWithMapping = "";
  isFromDataCheck: Boolean = false;
  isTempFlatfileUploaded: number;
  selectedRegionId: number;
  private maxsize = environment.maxFileSize * 1024 * 1024;
  timeOutHandler: NodeJS.Timer;
  isTimeIntervalInProgress = false;
  webJobQueueId: number;
  pageNumer: number;
  pageSize: number;
  totalRows: number;
  totalAsyncCalls = 0;
  confirmdisplay = false;
  showMappingConflictKey = "mappingConflict";
  langCode: string;
  currLangTranslation: any;
  nextStep: any;
  previousStep: any;
  mappingBtnText: string;
  accLibMatchValue: any = 5;
  db_langCode: string;
  db_currLangTranslation: any;
  EXCEL_CONTENT_TYPE: string =
    "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet";
  isMappingListEmpty: boolean = true;

  constructor(
    private infraService: InfraService,
    private mappingRemdService: MappingRemediationService,
    private route: ActivatedRoute,
    private router: Router,
    private sharedService: Sharedservice,
    private userService: UserService,
    private messageService: MessageService,
    private confirmationService: ConfirmationService,
    private engagementService: EngagementService,
    private logger: NGXLogger,
    private webJobQueueService: WebJobQueueService,
    private translateService: TranslateService,
    private http: HttpClient,
    private masterHelpService: MasterHelpService,
    private auditingService: AuditingService,
    private appConfigService: AppConfigurationService
  ) {
    this.isEngagementReadOnly =
      this.appConfigService.GetConfigValueByKey("IsProjectsReadOnly");
    this.infraService.infraDetails$.subscribe((data) => {
      this.selectedRegionId = data.InfraId;
      this.configUrl =
        data.WebEndPoint2 +
        "MappingRemediation/AddMappingUploadToQueue/" +
        this.engagementId;
    });
    this.finalheight = window.innerHeight - 350 + "px";
    this.options = {
      concurrency: 1,
      allowedContentTypes: [
        "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
        "application/vnd.ms-excel.sheet.macroEnabled.12",
      ],
    };

    this.sourceFiles = []; // local uploading files array
    this.uploadInput = new EventEmitter<UploadInput>(); // input events, we use this to emit data to ngx-uploader
    this.humanizeBytes = humanizeBytes;

    this.engagementId = +this.route.snapshot.paramMap.get("id");
    this.isFromDataCheck =
      this.route.snapshot.queryParams["from"] !== undefined &&
      this.route.snapshot.queryParams["from"].toLowerCase() === "datacheck";

    this.userService.cast.subscribe((userData: UserModel) => {
      if (userData.Id !== undefined) {
        this.loggedInUserId = userData.Id;
      }
    });
  }

  ngOnInit() {
    this.langCode = localStorage.getItem(LanguageConstants.LANG_CODE);
    this.currLangTranslation =
      this.translateService.translations[this.langCode];
    this.mappingBtnText = this.currLangTranslation.step6.showMappingBtn;
    this.nextStep = this.currLangTranslation.actionButtons.nextStep;
    this.previousStep = this.currLangTranslation.actionButtons.previousStep;

    this.pageNumer = 1;
    this.pageSize = environment.pageSize;
    this.totalRows = 0;
    this.suggestionListFlag = false;
    this.isTempFlatfileUploaded = this.sharedService.getLocalStorageValueByName(
      "isTempFlatfileUploaded" + this.engagementId + this.selectedRegionId
    );
    // this.engagementService
    //   .getEngagement(this.engagementId)
    //   .subscribe((data: EngagementModel) => {

    //     this.engagement.IsPnP = data.IsPnP;
    //   });

    if (this.isTempFlatfileUploaded === 1) {
      if (
        this.engagementService.engModel.IsPnP &&
        this.engagementService.engModel.TemplateId != 3 && this.engagementService.engModel.AccCalendarId  === 1
      )
        this.sharedService.setactiveindex(3);
      else this.sharedService.setactiveindex(2);

      this.fileUploadedAsTemplateFlatfile = false;
    } else {
      this.sharedService.setactiveindex(5);
      this.fileUploadedAsTemplateFlatfile = false;
    }
    this.loadRemediationMappingsWithDbLanguage("init");
    this.checkAutomatedMappingConflict();

    this.translateService.onLangChange.subscribe(
      (langEvent: LangChangeEvent) => {
        this.currLangTranslation = langEvent.translations;
        this.mappingBtnText = this.currLangTranslation.step6.showMappingBtn;
        this.nextStep = this.currLangTranslation.actionButtons.nextStep;
        this.previousStep = this.currLangTranslation.actionButtons.previousStep;
        this.cols = [
          { field: "AccountMappingDetailsId", header: "", visible: false },
          { field: "MappingId", header: "", visible: false },
          { field: "isDeleted", header: "", visible: true },
          {
            field: "isSelected",
            header: this.currLangTranslation.step6.isSelected,
            visible: true,
          },
          {
            field: "AccId",
            header: this.currLangTranslation.step6.accountIDTableColHeader,
            visible: true,
          },
          {
            field: "AccDescription",
            header:
              this.currLangTranslation.step6.accountDescriptionTableColHeader,
            visible: true,
          },
          {
            field: "CleanedAccountDescription",
            header:
              this.currLangTranslation.step6
                .cleanedAccountDescriptionTableColHeader,
            visible: false,
          },
          {
            field: "Mapping2",
            header: this.currLangTranslation.step6.mapping2TableColHeader,
            visible: false,
          },
          {
            field: "Mapping3",
            header: this.currLangTranslation.step6.mapping3TableColHeader,
            visible: false,
          },
          {
            field: "Mapping4",
            header: this.currLangTranslation.step6.mapping4TableColHeader,
            visible: false,
          },
          {
            field: "Mapping5",
            header: this.currLangTranslation.step6.mapping5TableColHeader,
            visible: false,
          },
          {
            field: "Mapping6",
            header: this.currLangTranslation.step6.mapping6TableColHeader,
            visible: false,
          },
          {
            field: "Mapping7",
            header: this.currLangTranslation.step6.mapping7TableColHeader,
            visible: false,
          },
          {
            field: "StandardizedMapping",
            header:
              this.currLangTranslation.step6.standarziedMappingTableColHeader,
            visible: true,
          },
          {
            field: "MappingSuggestions",
            header: this.currLangTranslation.step6.suggestionsTableColHeader,
            visible: true,
          },
          {
            field: "AccLibraryMatch",
            header:
              this.currLangTranslation.step6.accountlibrarymatchTableColHeader,
            visible: true,
          },
        ];
      }
    );
  }

  loadRemediationMappings(calledFrom: string) {
    this.loadspinner = true;
    this.cols = [
      { field: "AccountMappingDetailsId", header: "", visible: false },
      { field: "MappingId", header: "", visible: false },
      { field: "isDeleted", header: "", visible: true },
      {
        field: "isSelected",
        header: this.currLangTranslation.step6.isSelected,
        visible: true,
      },
      {
        field: "AccId",
        header: this.currLangTranslation.step6.accountIDTableColHeader,
        visible: true,
      },
      {
        field: "AccDescription",
        header: this.currLangTranslation.step6.accountDescriptionTableColHeader,
        visible: true,
      },
      {
        field: "CleanedAccountDescription",
        header:
          this.currLangTranslation.step6
            .cleanedAccountDescriptionTableColHeader,
        visible: false,
      },
      {
        field: "Mapping2",
        header: this.currLangTranslation.step6.mapping2TableColHeader,
        visible: false,
      },
      {
        field: "Mapping3",
        header: this.currLangTranslation.step6.mapping3TableColHeader,
        visible: false,
      },
      {
        field: "Mapping4",
        header: this.currLangTranslation.step6.mapping4TableColHeader,
        visible: false,
      },
      {
        field: "Mapping5",
        header: this.currLangTranslation.step6.mapping5TableColHeader,
        visible: false,
      },
      {
        field: "Mapping6",
        header: this.currLangTranslation.step6.mapping6TableColHeader,
        visible: false,
      },
      {
        field: "Mapping7",
        header: this.currLangTranslation.step6.mapping7TableColHeader,
        visible: false,
      },
      {
        field: "StandardizedMapping",
        header: this.currLangTranslation.step6.standarziedMappingTableColHeader,
        visible: true,
      },
      {
        field: "MappingSuggestions",
        header: this.currLangTranslation.step6.suggestionsTableColHeader,
        visible: true,
      },
      {
        field: "AccLibraryMatch",
        header:
          this.currLangTranslation.step6.accountlibrarymatchTableColHeader,
        visible: true,
      },
      { field: "SMId", header: "", visible: false },
    ];

    this.totalAsyncCalls++;
    this.mappingRemdService.getMappingData(this.engagementId).subscribe(
      (data) => {
        this.globalStdMapping = data;
        this.isMappingListEmpty =
          this.globalStdMapping && this.globalStdMapping.length > 0
            ? false
            : true;
            if(this.engagementService.engModel.IsCustomizedEngagement)
            {
             this.globalStdMapping.forEach((element: any) => {
             element.StandardizedMapping = element.StandardizedMapping; //this.db_currLangTranslation.stdMappings[element.StandardizedMapping]; need change for plug and play
             });
           }
           else
           {
            this.globalStdMapping.forEach((element: any) => {
              element.StandardizedMapping = this.db_currLangTranslation.stdMappings[element.StandardizedMapping];
              });
           }
        if (calledFrom === "upload") {
          this.getSourceMappingData(
            1,
            "AccountDescription",
            "ASC",
            null,
            null,
            "5",
            [],
            null,
            null,
            null,
            null,
            null,
            null,
            null
          );
        }
        this.totalAsyncCalls++;
        this.userService.cast.subscribe(
          (userData) => {
            if (userData.Id !== undefined) {
              this.loggedInUserId = userData.Id;
            }
            this.totalAsyncCalls--;
            this.loadspinner = this.totalAsyncCalls !== 0;
          },
          (err) => {
            this.totalAsyncCalls--;
            this.loadspinner = this.totalAsyncCalls !== 0;
          }
        );

        this.totalAsyncCalls++;
        this.mappingRemdService.getMappingSource(this.engagementId).subscribe(
          (data1: number[]) => {
            this.totalAsyncCalls--;
            if (data1.length === 2) {
              this.mappingSource = data1[0];
              this.mappingCount = data1[1]; // gives the mapping count (M2 to M7) to show in grid
            }
            this.loadspinner = this.totalAsyncCalls !== 0;
          },
          (err) => {
            this.totalAsyncCalls--;
            this.loadspinner = this.totalAsyncCalls !== 0;
          }
        );

        this.totalAsyncCalls--;
        this.loadspinner = this.totalAsyncCalls !== 0;
      },
      (err) => {
        this.totalAsyncCalls--;
        this.loadspinner = this.totalAsyncCalls !== 0;
      }
    );
  }

  // Clears suggestions mapping form values.
  resetSuggestionsMappingFormValues(multiSelect) {
    const filterValue = (<HTMLInputElement>(
      document.querySelector(".p-multiselect-filter")
    )).value;
    if (
      (filterValue === null ||
        filterValue === undefined ||
        filterValue === "") &&
      this.selecteditemsRoot.length === 0
    ) {
      this.suggestionCondition = "OR";
      return;
    } else if (
      this.selecteditemsRoot.length > 0 &&
      (filterValue === null || filterValue === undefined || filterValue === "")
    ) {
      this.resetSuggestionFilterValues(multiSelect);
    } else if (
      this.selecteditemsRoot.length > 0 ||
      multiSelect.filterValue !== null ||
      filterValue !== undefined ||
      filterValue !== ""
    ) {
      this.resetSuggestionFilterValues(multiSelect);
    }
  }

  // Resetting Mapping suggestion filter values
  resetSuggestionFilterValues(multiSelect: any) {
    (<HTMLInputElement>document.querySelector(".p-multiselect-filter")).value =
      "";
    multiSelect.filterValue = "";
    this.selecteditemsRoot = [];
    this.selectedSuggestionData = [];
    this.suggestionCondition = "OR";
    multiSelect.visibleOptions = multiSelect._options;
    this._table.filter(null, "MappingSuggestions", null);
  }

  getSourceMappingData(
    pageNumber: number,
    sortColumn: string,
    sortOrder: string,
    filterAccId: string,
    filterAccDescription: string,
    filterLibrary: string,
    filterMappingSuggestions: any,
    suggestionCondition,
    filterMapping2: string,
    filterMapping3: string,
    filterMapping4: string,
    filterMapping5: string,
    filterMapping6: string,
    filterMapping7: string
  ) {
    this.totalAsyncCalls++;
    this.loadspinner = true;
    this.mappingRemdService
      .getMappingSuggestion(
        this.engagementId,
        pageNumber,
        this.pageSize,
        sortColumn,
        sortOrder,
        filterAccId,
        filterAccDescription,
        filterLibrary,
        filterMappingSuggestions,
        suggestionCondition,
        filterMapping2,
        filterMapping3,
        filterMapping4,
        filterMapping5,
        filterMapping6,
        filterMapping7
      )
      .subscribe(
        (data: any) => {
          let mappingSuggestionData = [];
          const mappingSuggestionUniqueData = [];
          const list = [...data.MappingSuggestionList];
          this.totalRows = data.TotalRows;
          this.mapData = data.MappingSuggestionList;
          // We need entire suggestion data even we filter the data also
          if (!this.suggestionListFlag) {
            this.suggestionListFlag = true;
            mappingSuggestionData = list.map((item) => {
              return JSON.parse(item.MappingSuggestions);
            });
            // Removing duplicates for mapping suggestion list
            mappingSuggestionData.forEach((value, index) => {
              value.map((val, i) => {
                if (mappingSuggestionUniqueData.indexOf(val) === -1) {
                  if (val !== "Undefined") {
                    mappingSuggestionUniqueData.push(val);
                  }
                }
              });
            });
            // Suggestions multiselect final list
            this.mappngSuggestion = mappingSuggestionUniqueData.map(
              (val, i) => {
                return { label: val };
              }
            );
          } else {
            this.mappngSuggestion = this.mappngSuggestion;
          }
          this.logger.info("Mapping suggestion success " + this.mapData.length);
          this.mapData.map((item) => {
            item.MappingSuggestions = JSON.parse(item.MappingSuggestions);
            this.standardizedMappingChange(item, true);
          });
          this.totalAsyncCalls--;
          this.loadspinner = this.totalAsyncCalls !== 0;
        },
        (err) => {
          this.totalAsyncCalls--;
          this.loadspinner = this.totalAsyncCalls !== 0;
        }
      );
  }

  mappingSuggestionsItemSelected(selectedValue) {
    if (selectedValue.value.length > 0) {
      this.selectedSuggestionData = selectedValue.value.map((val) => val.label);
      this._table.filter(
        this.selectedSuggestionData,
        "MappingSuggestions",
        this.suggestionCondition
      );
    } else {
      this.selectedSuggestionData = [];
      this._table.filter(
        this.selectedSuggestionData,
        "MappingSuggestions",
        this.suggestionCondition
      );
    }
  }

  updateAmount() {
    this.mappingRemdService.updateAmount(this.engagementId).subscribe(
      (resp: any) => {
        this.loadspinner = false;
        if (resp["message"] === "success") {
          this.redirectToDataCheck();
        } else {
          this.loadspinner = false;
          this.messageService.add({
            key: severitymessage.key,
            severity: severitymessage.error,
            summary: this.currLangTranslation.severitymessage.notification,
            detail: this.currLangTranslation.severitymessage.somethingwrong,
            sticky: true,
            closable: true,
          });
        }
      },
      (err) => {
        this.loadspinner = false;
        this.messageService.add({
          key: severitymessage.key,
          severity: severitymessage.error,
          summary: this.currLangTranslation.severitymessage.notification,
          detail: this.currLangTranslation.severitymessage.somethingwrong,
          sticky: true,
          closable: true,
        });
      }
    );
  }

  nextClicked(event) {
    if (!this.isEngagementReadOnly) {
      if (this.checkvalidation() === "ok") {
        this.showWarningPopup();
      } else {
        this.errorModel.confirmIsDisplay = true;
        this.errorModel.displayMessage =
          this.currLangTranslation.remediationComponentmessage.ErrorMessage.MappingError;
        this.errorModel.headerTitle = this.currLangTranslation.labels.error;
      }
      this.messageService.clear();
    } else {
      this.loadspinner = true;
      this.updateAmount();
    }
  }

  showWarningPopup() {
    if (!this.engagementService.engModel.IsCustomizedEngagement) {
      this.confirmationService.confirm({
        key: this.normalConfirmKey,
        message:
          this.currLangTranslation.remediationComponentmessage.confirmMessage
            .PushLibrary,
        header: this.currLangTranslation.labels.warning,
        acceptLabel: this.currLangTranslation.actionButtons.yes,
        rejectLabel: this.currLangTranslation.actionButtons.no,
        accept: () => {
          this.UpdateAmountOnAccept();
        },

        reject: () => {
          const target = event.currentTarget as HTMLElement;
          if (target.id === "btnMappingConfirmNo") {
            this.loadspinner = true;
            this.updateAmount();
          } else {
            // Close(x) button execution of popup
            // Hide the loadspinner when user is performing submit standard mapping to library => Go Back click => Close(x) button click
            this.loadspinner = false;
          }
        },
      });
    } else {
      this.updateAmount();
    }
  }

  UpdateAmountOnAccept() {
    this.loadspinner = true;
    this.confirmationService.confirm({
      key: this.libraryConfirmCustomKey,
      message:
        this.currLangTranslation.remediationComponentmessage.confirmMessage
          .PushLibraryLongMsg,
      header: this.currLangTranslation.labels.warning,
      acceptLabel: this.currLangTranslation.actionButtons.yes,
      rejectLabel: this.currLangTranslation.actionButtons.no,
      accept: () => {
        this.mappingRemdService
          .pushMappingIntoLibrary(this.engagementId, this.loggedInUserId)
          .subscribe(
            (data: any) => {
              if (data.message === "success") {
                this.updateAmount();
              } else {
                this.loadspinner = false;
                this.messageService.add({
                  key: severitymessage.key,
                  severity: severitymessage.error,
                  summary:
                    this.currLangTranslation.severitymessage.notification,
                  detail:
                    this.currLangTranslation.severitymessage.somethingwrong,
                  sticky: true,
                  closable: true,
                });
              }
            },
            (err) => {
              this.loadspinner = false;
              this.messageService.add({
                key: severitymessage.key,
                severity: severitymessage.error,
                summary: this.currLangTranslation.severitymessage.notification,
                detail: this.currLangTranslation.severitymessage.somethingwrong,
                sticky: true,
                closable: true,
              });
            }
          );
      },
      reject: () => {
        this.showWarningPopup();
      },
    });
  }

  redirectToDataCheck() {
    this.sharedService.setactiveindex(6);
    this.router.navigate([
      "/engagement/",
      this.engagementId,
      "performdatacheck",
    ]);
  }

  closeEventworkallocation($event) {
    this.confirmdisplay = $event;
  }

  previousButton() {
    this.confirmdisplay = false;
    if (this.isTempFlatfileUploaded === 1) {
      this.engagementService
        .getEngagement(this.engagementId)
        .subscribe((data) => {
          if (data.RedirectToVerification) {
            this.router.navigate([
              "/engagement/",
              this.engagementId,
              "uploaddownloadflatfile",
            ]);
          } else {
            this.router.navigate([
              "/engagement/",
              this.engagementId,
              "mappingselection",
            ]);
          }
        });
    } else {
      this.router.navigate([
        "/engagement/",
        this.engagementId,
        "mappingselection",
      ]);
    }
  }

  applyAll(isChecked) {
    this.checkAll = true;
    let newTable = [];
    newTable = JSON.parse(JSON.stringify(this.mapData));
    newTable.map((item) => {
      isChecked ? (item.isSelected = true) : (item.isSelected = false);
    });
    this.mapData = newTable;
  }

  updateApplyall() {
    let count = 0;
    this.mapData.forEach((item) => {
      if (item.isSelected) {
        count++;
      }
    });
    if (count === this.totalRows) {
      this.checkAll = true;
    } else {
      this.checkAll = false;
    }
  }

  stdMappingHeaderChange(event) {
    let existingTable = [];
    existingTable = JSON.parse(JSON.stringify(this.mapData));
    let filteredRows;
    if (this._table.filteredValue !== undefined) {
      filteredRows = this._table.filteredValue.filter((x) => x.isSelected);
    } else {
      filteredRows = this.mapData.filter((x) => x.isSelected);
    }

    filteredRows.map((row) => {
      row["SMId"] = event.target.value;
      row["StandardizedMapping"] = this.globalStdMapping.filter(
        (x) => x.Id == event.target.value
      )[0]?.StandardizedMapping;
      if (
        row["MappingSuggestions"].length > 0 &&
        row["MappingSuggestions"][0] !== "Undefined"
      ) {
        row["MappingSuggestions"].includes(event.target.value)
          ? ((row.ClassName = this.getClassNamesForAccLibrary("found")),
            (row["AccLibraryMatch"] = AccountLibraryMatch.Found))
          : ((row.ClassName = this.getClassNamesForAccLibrary("warning")),
            (row["AccLibraryMatch"] = AccountLibraryMatch.Warning));
      }
    });

    if (filteredRows.length > 0 && event.target.value !== "Please select") {
      this.loadspinner = true;
      this.mappingRemdService
        .saveMappings(filteredRows, this.engagementId)
        .subscribe(
          (data) => {
            if (data["message"] !== "success") {
              this.mapData = existingTable;
              this.messageService.add({
                key: this.currLangTranslation.severitymessage.key,
                severity: severitymessage.error,
                summary: this.currLangTranslation.severitymessage.notification,
                detail: this.currLangTranslation.severitymessage.somethingwrong,
                sticky: true,
                closable: true,
              });
            }
            this.loadspinner = false;
          },
          (err) => {
            this.mapData = existingTable;
            this.loadspinner = false;
            this.messageService.add({
              key: severitymessage.key,
              severity: severitymessage.error,
              summary: this.currLangTranslation.severitymessage.notification,
              detail: this.currLangTranslation.severitymessage.somethingwrong,
              sticky: true,
              closable: true,
            });
          }
        );
    }
  }

  accountLibraryChange(event, onPageLoad: boolean) {
    const newTable = [];
    this.accLibMatchValue = event.target.value;
    if (event.target.value === "2") {
      this.variable = "fa fa-exclamation-triangle customiconyello";
    }

    if (event.target.value === "3") {
      this.variable = "fa fa-minus-square customdashrem ";
    }

    if (event.target.value === "4") {
      this.variable = "fa fa-check-circle customicon";
    }
    if (event.target.value === "5") {
      this.variable = "blckcol";
      this._table.filter("5", "AccLibraryMatch", "equals");
    }

    if (event.target.value !== "5") {
      if (event.target.value === "3") {
        this._table.filter("1", "AccLibraryMatch", "in");
      } else {
        this._table.filter(
          "" + event.target.value,
          "AccLibraryMatch",
          "equals"
        );
      }
    }
  }

  checkvalidation(): string {
    let flag = "ok";
    this.loadIsvalid = true;
    this.mapData.forEach((item) => {
      if (
        item.StandardizedMapping === "" ||
        item.StandardizedMapping === "0" ||
        item.StandardizedMapping === "Undefined" ||
        item.StandardizedMapping === "Please select" ||
        item.StandardizedMapping === undefined
      ) {
        flag = "notselected";
      }
    });
    return flag;
  }

  Isvalid(mapping: string): boolean {
    if (
      mapping === "" ||
      mapping === "0" ||
      mapping === "Undefined" ||
      mapping === "0: " ||
      mapping === "Please select"
    ) {
      return true;
    }
    return false;
  }

  suggestionChange(event: any, id: number) {
    if (!this.isEngagementReadOnly) {
      let filteredRow = this.mapData.filter((item) => item.MappingId === id);
      filteredRow = filteredRow.map((x) => {
        x["SMId"] = this.globalStdMapping.filter(
          (x) => x.StandardizedMapping == event.target.innerText.trim()
        )[0].Id;
        x["StandardizedMapping"] = event.target.innerText.trim();
      });
    }
  }

  deleteMultiMapping() {
    if (!this.isEngagementReadOnly) {
      this.deleteMapping(
        this.mapData
          .filter((x) => x.isSelected)
          .map((o) => ({
            AccountMappingDetailsId: o.AccountMappingDetailsId,
            MappingId: o.MappingId,
          }))
      );
    }
  }

  deleteMapping(mappingDeleteData: any) {
    if (!this.isEngagementReadOnly) {
      if (mappingDeleteData.length > 0) {
        this.confirmationService.confirm({
          key: this.normalConfirmKeyDelete,
          message:this.currLangTranslation.remediationComponentmessage.confirmMessage.confirmDelete,
          header: this.currLangTranslation.labels.warning,
          acceptLabel: this.currLangTranslation.actionButtons.yes,
          rejectLabel: this.currLangTranslation.actionButtons.no,
          accept: () => {
            this.loadspinner = true;
            this.mappingRemdService.deleteMapping(mappingDeleteData).subscribe(
              (data) => {
                const ids = mappingDeleteData.map(
                  (o) => o.AccountMappingDetailsId
                );
                this.mapData = this.mapData.filter(
                  (obj) => !ids.includes(obj.AccountMappingDetailsId)
                );
                this.messageService.add({
                  key: severitymessage.key,
                  severity: severitymessage.success,
                  summary:
                    this.currLangTranslation.severitymessage.notification,
                  detail:
                    this.currLangTranslation.remediationComponentmessage
                      .SuccessMessage.MappingDelete,
                  sticky: true,
                  closable: true,
                });
                this.loadspinner = false;
              },
              (err) => {
                this.messageService.add({
                  key: severitymessage.key,
                  severity: severitymessage.warn,
                  summary:
                    this.currLangTranslation.severitymessage.notification,
                  detail:
                    this.currLangTranslation.remediationComponentmessage
                      .ErrorMessage.MappingDeleteError,
                  sticky: true,
                  closable: true,
                });
                this.loadspinner = false;
              }
            );
          },
          reject: () => {},
        });
      }
    }
  }

  standardizedMappingChange(data: any, onPageLoad: boolean) {
    if (!this.isEngagementReadOnly) {
      let className = "";
      if (onPageLoad === undefined) {
        const stdMap = this.globalStdMapping.filter(
          (x) => x.Id == data["SMId"]
        )[0]?.StandardizedMapping;
        data["StandardizedMapping"] = stdMap === undefined ? "" : stdMap;
      }
      const selectedSM: string = data["StandardizedMapping"];
      const suggestions: Array<any> = data["MappingSuggestions"];
      if (!onPageLoad) {
        if (data.StandardizedMapping !== "") {
          const dataArr = [];
          dataArr.push(data);
          this.loadspinner = true;
          this.mappingRemdService
            .saveMappings(dataArr, this.engagementId)
            .subscribe(
              (data) => {
                this.loadspinner = false;
                if (data["message"] !== "success") {
                  data["StandardizedMapping"] = "";
                  data["AccLibraryMatch"] = AccountLibraryMatch.Warning;
                  data["ClassName"] =
                    this.getClassNamesForAccLibrary("warning");
                  this.messageService.add({
                    key: severitymessage.key,
                    severity: severitymessage.error,
                    summary:
                      this.currLangTranslation.severitymessage.notification,
                    detail:
                      this.currLangTranslation.severitymessage.somethingwrong,
                    sticky: true,
                    closable: true,
                  });
                }
              },
              (err) => {
                data["StandardizedMapping"] = "";
                data["AccLibraryMatch"] = AccountLibraryMatch.Warning;
                data["ClassName"] = this.getClassNamesForAccLibrary("warning");
                this.loadspinner = false;
                this.messageService.add({
                  key: severitymessage.key,
                  severity: severitymessage.error,
                  summary:
                    this.currLangTranslation.severitymessage.notification,
                  detail:
                    this.currLangTranslation.severitymessage.somethingwrong,
                  sticky: true,
                  closable: true,
                });
              }
            );
        }
      }

      if (selectedSM !== undefined && selectedSM !== "Please select") {
        if (suggestions[0] === "Undefined") {
          className = this.getClassNamesForAccLibrary("notfound");
          data["AccLibraryMatch"] = AccountLibraryMatch.NotFound;
        } else if (
          suggestions[0] != null &&
          suggestions.indexOf(selectedSM) !== -1
        ) {
          className = this.getClassNamesForAccLibrary("found");
          data["AccLibraryMatch"] = AccountLibraryMatch.Found;
        } else {
          className = this.getClassNamesForAccLibrary("warning");
          data["AccLibraryMatch"] = AccountLibraryMatch.Warning;
        }
      }
      if (selectedSM === "") {
        className = this.getClassNamesForAccLibrary("notfound");
        data["AccLibraryMatch"] = AccountLibraryMatch.SMIDNOTSelected;
        data["SMId"] = "";
      }
      data.ClassName = className;
    }
  }
  getClassNamesForAccLibrary(forWhat) {
    switch (forWhat) {
      case "found":
        return "fa fa-check-circle customicon";
      case "notfound":
        return "fa fa-minus-square customdash";
      case "warning":
        return "fa fa-exclamation-triangle customiconyello";
    }
  }

  showMapping() {
    const columns = JSON.parse(JSON.stringify(this._table.columns));
    this.isMappingVisible
      ? ((this.mappingBtnText = this.currLangTranslation.step6.showMappingBtn),
        (this.isMappingVisible = !this.isMappingVisible))
      : ((this.mappingBtnText = this.currLangTranslation.step6.hideMappingBtn),
        (this.isMappingVisible = !this.isMappingVisible));
    let counter = 0;
    columns.map((item) => {
      item.field !== "MappingId" &&
      item.field.startsWith("Mapping") &&
      this.mappingCount > counter
        ? ((item.visible = !item.visible), (counter += 1))
        : "";
    });

    this.cols = columns;
    if (this.isMappingVisible) {
      this.verificationWithMapping = "verification-with-mapping-table";
    } else {
      this.verificationWithMapping = null;
    }
  }

  Downloadclick(event: any) {
    this.loadspinnerdownloadmapping = true;
    this.uploadDisabled = true;

    forkJoin([
      this.engagementService.getEngagement(this.engagementId),
      this.mappingRemdService.getMappingfile(this.engagementId),
    ]).subscribe((results: any) => {
      this.loadspinnerdownloadmapping = false;
      const enggModel: EngagementModel = results[0];
      const fileContent = results[1];
      const today = new Date();
      let todayDateString: any;
      let downloadfileName = enggModel.EngagementName;

      if (fileContent) {
        this.http
          .get(`../assets/i18n/${enggModel.LanguageCode}.json`)
          .subscribe((i18n: any) => {
            if (
              enggModel.TemplateId === 0 ||
              enggModel.TemplateId === TemplateEnum.Americas
            ) {
              todayDateString =
                ("0" + (today.getMonth() + 1)).slice(-2) +
                ("0" + today.getDate()).slice(-2) +
                today.getFullYear();
              downloadfileName +=
                `_${i18n.labels.downloadManualMappingSuffixName}_` +
                `${todayDateString}.xlsx`;
            } else {
              todayDateString =
                ("0" + today.getDate()).slice(-2) +
                ("0" + (today.getMonth() + 1)).slice(-2) +
                today.getFullYear();
              downloadfileName +=
                `_${i18n.labels.downloadManualMappingSuffixName}_` +
                `${todayDateString}.xlsx`;
            }
            saveAs(fileContent, downloadfileName);
          });
      } else {
        this.loadspinnerdownloadmapping = false;
        this.uploadDisabled = false;

        this.messageService.add({
          key: severitymessage.key,
          severity: severitymessage.error,
          summary: this.currLangTranslation.severitymessage.notification,
          detail: this.currLangTranslation.severitymessage.somethingwrong,
          sticky: true,
          closable: true,
        });
      }
    });
  }

  // Download functionalit from here
  onUploadOutput(output: UploadOutput, fileInput: any): void {
    if (this.uploadDisabled) {
      if (output.type === "allAddedToQueue") {
        // when all files added in queue
        // uncomment this if you want to auto upload files when added
        if (this.sourceFiles.length > 0) {
          this.loadspinneruploadmapping = true;
          const event: UploadInput = {
            type: "uploadAll",
            url: this.configUrl,
            method: "POST",
            data: {
              loggedInUserId: <any>this.loggedInUserId,
              mappingSource: <any>this.mappingSource,
              engagementId: <any>this.engagementId,
            },
            headers: {
              Authorization:
                "Bearer " +
                (environment.isBearerAuthorizationEnabled
                  ? localStorage["dbamsaltoken"]
                  : environment.sampleToken),
            },
          };
          this.uploadInput.emit(event);
        }
      } else if (
        output.type === "addedToQueue" &&
        typeof output.file !== "undefined"
      ) {
        // add file to array when added
        if (output.file.size > this.maxsize) {
          fileInput.value = "";
          this.loadspinneruploadmapping = false;
          this.errorModel.confirmIsDisplay = true;
          this.errorModel.displayMessage =
            this.currLangTranslation.severitymessage.MaxsizeError +
            " " +
            output.file.name +
            "  " +
            this.currLangTranslation.severitymessage.ofSizeMoreThan +
            environment.maxFileSize +
            " MB";
        } else {
          this.sourceFiles.push(output.file);
        }
      } else if (
        output.type === "uploading" &&
        typeof output.file !== "undefined"
      ) {
        this.loadspinneruploadmapping = true;
        // update current data in files array for uploading file
        const index = this.sourceFiles.findIndex(
          (file) =>
            typeof output.file !== "undefined" && file.id === output.file.id
        );
        this.sourceFiles[index] = output.file;
      } else if (output.type === "done" && typeof output.file !== "undefined") {
        if (
          output.file &&
          output.file.response &&
          output.file.response.message === "Invalid File Format"
        ) {
          this.loadspinner = false;
          fileInput.value = "";
          this.uploadInput.emit({ type: "remove", id: output.file.id });
          this.errorModel.confirmIsDisplay = true;
          this.errorModel.displayMessage =
            this.currLangTranslation.UploadSourcefilemessage.ErrorMessage.FormateError;
          return;
        }

        if (this.sourceFiles[0].responseStatus === 400) {
          if (this.sourceFiles[0].response.statusId === 422) {
            // 422 status id means queue is already present for flatfileupload
            this.errorModel.confirmIsDisplay = true;
            this.errorModel.headerTitle = "Notification";
            this.errorModel.displayMessage =
              this.currLangTranslation.remediationComponentmessage.ErrorMessage.QueueInProgress;
            this.loadspinneruploadmapping = false;
          } else {
            this.loadspinneruploadmapping = false;
            this.uploadDisabled = true;
            this.messageService.add({
              key: severitymessage.key,
              severity: severitymessage.error,
              summary: this.currLangTranslation.severitymessage.notification,
              detail: this.currLangTranslation.severitymessage.FormateError,
              sticky: true,
              closable: true,
            });
          }
        } else {
          if (this.sourceFiles[0].response.status === severitymessage.success) {
            this.webJobQueueId = this.sourceFiles[0].response.id;
            this.checkMappingUploadProcessed();
          } else {
            this.loadspinneruploadmapping = false;
            this.uploadDisabled = true;
            this.messageService.add({
              key: severitymessage.key,
              severity: severitymessage.error,
              summary: this.currLangTranslation.severitymessage.notification,
              detail: this.currLangTranslation.severitymessage.somethingwrong,
              sticky: true,
              closable: true,
            });
          }
        }
        this.sourceFiles = [];
        // Clear file - to upload same file name twice
        fileInput.value = "";
      } else if (
        output.type === "rejected" &&
        typeof output.file !== "undefined"
      ) {
        // Replace with Notification service
        this.loadspinneruploadmapping = false;
        this.uploadDisabled = true;
        this.errorModel.confirmIsDisplay = true;
        this.errorModel.displayMessage =
          this.currLangTranslation.UploadSourcefilemessage.ErrorMessage.FormateError;
      } else if (output.type === "removed") {
        // remove file from array when removed
        this.sourceFiles = this.sourceFiles.filter(
          (file: UploadFile) => file !== output.file
        );
        this.loadspinneruploadmapping = false;
      } else if (output.type === "dragOver") {
        this.dragOver = true;
      } else if (output.type === "dragOut") {
        this.dragOver = false;
      } else if (output.type === "drop") {
        this.dragOver = false;
      }
    }
  }

  cancelUpload(id: string): void {
    this.uploadInput.emit({ type: "cancel", id: id });
  }

  removeFile(id: string): void {
    this.uploadInput.emit({ type: "remove", id: id });
  }

  removeAllFiles(): void {
    this.uploadInput.emit({ type: "removeAll" });
  }
  gotoflatefile() {
    this.loadspinner = false;
    this.router.navigate([
      "/engagement/",
      this.engagementId,
      "performdatacheck",
    ]);
  }

  // Download Events
  onResize(event) {
    this.finalheight = window.innerHeight - 350 + "px";
  }

  suggestionRemove(event: any, data: any) {
    if (!this.isEngagementReadOnly) {
      this.confirmationService.confirm({
        message:
          this.currLangTranslation.remediationComponentmessage.confirmMessage
            .DeleteSuggestion,
        acceptLabel: this.currLangTranslation.actionButtons.yes,
        rejectLabel: this.currLangTranslation.actionButtons.no,
        accept: () => {
          this.loadspinner = true;
          const deleteValue = event.target.parentElement.innerText;
          const isSameSuggestionAndStdMapping =
            data["StandardizedMapping"] === deleteValue;
          this.mappingRemdService
            .deleteSuggestion(
              data["MappingId"],
              data["CleanedAccountDescription"],
              deleteValue,
              isSameSuggestionAndStdMapping
            )
            .subscribe(
              (res) => {
                if (res["message"] === "success") {
                  this.mapData = this.mapData.map((a) => {
                    if (
                      a["AccountMappingDetailsId"] ===
                      data["AccountMappingDetailsId"]
                    ) {
                      const idx = a["MappingSuggestions"].indexOf(deleteValue);
                      if (idx !== -1) {
                        a["MappingSuggestions"].splice(idx, 1);
                        isSameSuggestionAndStdMapping
                          ? ((a["StandardizedMapping"] = ""),
                            (a["ClassName"] =
                              this.getClassNamesForAccLibrary("warning")),
                            (a["AccLibraryMatch"] =
                              AccountLibraryMatch.Warning))
                          : "";
                      }
                    }
                    return a;
                  });
                }
                this.loadspinner = false;
              },
              (err) => {
                this.loadspinner = false;
              }
            );
        },
        reject: () => {},
      });
    }
  }
  checkMappingUploadProcessed() {
    this.webJobQueueService.getWebJobQueue(this.webJobQueueId).subscribe(
      (resp: WebJobQueueModel) => {
        if (resp) {
          if (!resp.isQueued) {
            this.loadspinneruploadmapping = false;
            this.isTimeIntervalInProgress = false;

            clearInterval(this.timeOutHandler);

            if (resp.isError) {
              this.uploadDisabled = true;
              if (resp.responseText === "") {
                this.messageService.add({
                  key: severitymessage.key,
                  severity: severitymessage.error,
                  summary:
                    this.currLangTranslation.severitymessage.notification,
                  detail:
                    this.currLangTranslation.severitymessage.somethingwrong,
                  sticky: true,
                  closable: true,
                });
              } else {
                // Showing multiple validation messages.
                this.errorModel.confirmIsDisplay = true;
                this.errorModel.displayMessage = resp.responseText.split("@@");
              }
            } else {
              this.uploadDisabled = false;
              this.messageService.add({
                key: severitymessage.key,
                severity: severitymessage.success,
                summary: this.currLangTranslation.severitymessage.notification,
                detail: this.currLangTranslation.severitymessage.FileUpload,
                sticky: true,
                closable: true,
              });
              this.loadRemediationMappingsWithDbLanguage("upload");
              this.selecteditemsRoot = [];
              this.selectedSuggestionData = [];
              // this.getSourceMappingData(1, 'AccountDescription', 'ASC', null, null, '5', [], null, null, null, null, null, null, null);
            }
          } else {
            if (!this.isTimeIntervalInProgress) {
              this.timeOutHandler = setInterval(() => {
                this.isTimeIntervalInProgress = true;
                this.loadspinneruploadmapping = true;
                this.checkMappingUploadProcessed();
              }, environment.webjobTimer);
            }
          }
        } else {
          if (!this.isTimeIntervalInProgress) {
            this.timeOutHandler = setInterval(() => {
              this.isTimeIntervalInProgress = true;
              this.loadspinneruploadmapping = true;
              this.checkMappingUploadProcessed();
            }, environment.webjobTimer);
          }
        }
      },
      (err) => {
        this.loadspinneruploadmapping = false;
        this.isTimeIntervalInProgress = false;
        clearInterval(this.timeOutHandler);
        this.messageService.add({
          key: severitymessage.key,
          severity: severitymessage.error,
          summary: this.currLangTranslation.severitymessage.notification,
          detail: this.currLangTranslation.severitymessage.somethingwrong,
          sticky: true,
          closable: true,
        });
      }
    );
  }

  loadMappingDataLazy(event: LazyLoadEvent) {
    this.pageNumer = event.first / this.pageSize + 1;
    const sortColumn =
      event.sortField !== "" ? event.sortField : "AccDescription";
    const sortOrder = event.sortOrder === 1 ? "ASC" : "DESC";
    let filterAccId = null;
    let filterAccDescription = null;
    let filterMapping2 = null;
    let filterMapping3 = null;
    let filterMapping4 = null;
    let filterMapping5 = null;
    let filterMapping6 = null;
    let filterMapping7 = null;
    let filterLibrary = "5";
    let filterSuggestions = null;
    let suggestionCondition = null;
    filterAccId =
      typeof event.filters["AccId"] !== "undefined" &&
      event.filters["AccId"].value !== ""
        ? event.filters["AccId"].value
        : null;
    filterAccDescription =
      typeof event.filters["AccDescription"] !== "undefined" &&
      event.filters["AccDescription"].value !== ""
        ? event.filters["AccDescription"].value
        : null;
    filterLibrary =
      typeof event.filters["AccLibraryMatch"] !== "undefined" &&
      event.filters["AccLibraryMatch"].value !== ""
        ? event.filters["AccLibraryMatch"].value
        : "5";
    filterSuggestions =
      typeof event.filters["MappingSuggestions"] !== "undefined" &&
      event.filters["MappingSuggestions"].value !== ""
        ? event.filters["MappingSuggestions"].value
        : null;
    filterMapping2 =
      typeof event.filters["Mapping2"] !== "undefined" &&
      event.filters["Mapping2"].value !== ""
        ? event.filters["Mapping2"].value
        : null;
    filterMapping3 =
      typeof event.filters["Mapping3"] !== "undefined" &&
      event.filters["Mapping3"].value !== ""
        ? event.filters["Mapping3"].value
        : null;
    filterMapping4 =
      typeof event.filters["Mapping4"] !== "undefined" &&
      event.filters["Mapping4"].value !== ""
        ? event.filters["Mapping4"].value
        : null;
    filterMapping5 =
      typeof event.filters["Mapping5"] !== "undefined" &&
      event.filters["Mapping5"].value !== ""
        ? event.filters["Mapping5"].value
        : null;
    filterMapping6 =
      typeof event.filters["Mapping6"] !== "undefined" &&
      event.filters["Mapping6"].value !== ""
        ? event.filters["Mapping6"].value
        : null;
    filterMapping7 =
      typeof event.filters["Mapping7"] !== "undefined" &&
      event.filters["Mapping7"].value !== ""
        ? event.filters["Mapping7"].value
        : null;
    if (filterSuggestions === null) {
      suggestionCondition = null;
      this.selectedSuggestionData = [];
    } else {
      suggestionCondition = this.suggestionCondition;
    }
    this.getSourceMappingData(
      this.pageNumer,
      sortColumn,
      sortOrder,
      filterAccId,
      filterAccDescription,
      filterLibrary,
      this.selectedSuggestionData,
      suggestionCondition,
      filterMapping2,
      filterMapping3,
      filterMapping4,
      filterMapping5,
      filterMapping6,
      filterMapping7
    );
  }

  IsSortDisabled(column: string) {
    const disabledColumns = ["isSelected"];
    return disabledColumns.includes(column);
  }

  private checkAutomatedMappingConflict() {
    this.mappingRemdService
      .checkAutomatedMappingConflict(this.engagementId)
      .subscribe(
        (res: any) => {
          if (res.isDuplicate) {
            this.confirmationService.confirm({
              key: this.showMappingConflictKey,
              message:
                this.currLangTranslation.remediationComponentmessage
                  .confirmMessage.MappingConflict,
              header: this.currLangTranslation.labels.warning,
              acceptLabel: this.currLangTranslation.actionButtons.yes,
              rejectLabel: this.currLangTranslation.actionButtons.no,
              accept: () => {
                this.redirectToUserInput();
              },
              reject: () => {},
            });
          }
        },
        (err) => {}
      );
  }

  private redirectToUserInput() {
    this.sharedService.setactiveindex(2);
    this.router.navigate(["/engagement/", this.engagementId, "inputcapture"]);
  }

  private loadRemediationMappingsWithDbLanguage(calledFrom: string): void {
    this.engagementService.getEngagement(this.engagementId).subscribe(
      (data) => {
        if (this.db_langCode === this.langCode) {
          this.db_currLangTranslation = JSON.parse(
            JSON.stringify(this.currLangTranslation)
          );
          this.loadRemediationMappings(calledFrom);
        } else {
          this.http
            .get(`../assets/i18n/${data.LanguageCode}.json`)
            .subscribe((i18n) => {
              this.db_currLangTranslation = i18n;
              this.loadRemediationMappings(calledFrom);
            });
        }
      },
      (error) => {
        this.logger.info(
          "--------error logged in remediation.component.loadRemediationMappingsWithDbLanguage()----------" +
            error
        );
      }
    );
  }

  redirectPlugandPlay() {
    this.router.navigate(["/engagement/", this.engagementId, "layout"]);
  }
}
